<template>
  <div v-if="reseted">
    <video :disablePictureInPicture="disablePictureInPicture" class="video-js" ref="video">
      <track
        v-for="(crtTrack, index) in trackList"
        :key="index"
        :kind="crtTrack.kind"
        :label="crtTrack.label"
        :src="crtTrack.src"
        :srcLang="crtTrack.srcLang"
        :default="crtTrack.default"
      />
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank"
          >supports HTML5 video</a
        >
      </p>
    </video>
    <!--<div v-show="hasError" class="video-js">
      <div v-html="errorMsg" class="video-js"></div>
    </div>-->
  </div>
</template>

<script>
//import jQuery from "jquery";
//let $ = jQuery;
import "video.js/dist/video-js.css";
import _videojs from "video.js";
const videojs = window.videojs || _videojs;
import _videojsPlaylist from "videojs-playlist";
videojs.registerPlugin("videojs-playlist", _videojsPlaylist);
let vPlayer;
let vm;
export default {
  name: "videoplayer",
  props: {
    disablePictureInPicture: {
      type: Boolean,
      default: false
    },
    crossOrigin: {
      type: String,
      default: ""
    },
    playsinline: {
      type: Boolean,
      default: false
    },
    customEventName: {
      type: String,
      default: "statechanged"
    },
    options: {
      type: Object,
      required: true
    },
    events: {
      type: Array,
      default: () => []
    },
    globalOptions: {
      type: Object,
      default: () => ({
        autoplay: true,
        controls: true,
        language: "zh",
        inactivityTimeout: 0,
        preload: "auto",
        fluid: false,
        techOrder: ["html5"],
        plugins: {},
        controlBar:{
          pictureInPictureToggle: false
        }
      })
    },
    globalEvents: {
      type: Array,
      default: () => []
    },
    trackList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      player: null,
      reseted: true,
      hasError: false,
      errorMsg: ""
    };
  },
  methods: {
    initialize: function() {
      const self = this;
      const videoObj = this.$refs.video;
      // videojs options
      const videoOptions = Object.assign({}, this.globalOptions, this.options);
      // ios fullscreen
      if (this.playsinline) {
        videoObj.setAttribute("playsinline", this.playsinline);
        videoObj.setAttribute("webkit-playsinline", this.playsinline);
        videoObj.setAttribute("x5-playsinline", this.playsinline);
        videoObj.setAttribute("x5-video-player-type", "h5");
        videoObj.setAttribute("x5-video-player-fullscreen", false);
      }
      // cross origin
      if (this.crossOrigin !== "") {
        videoObj.crossOrigin = this.crossOrigin;
        videoObj.setAttribute("crossOrigin", this.crossOrigin);
      }
      // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }
      // emit event
      const emitPlayerState = (event, value) => {
        if (event) {
          this.$emit(event, this.player);
          //alert("event:" + event);
        }
        if (value) {
          //alert("value:" + value);
          this.$emit(this.customEventName, { [event]: value });
          if (event == "error") {
            //alert("error event value:" + value);
            this.onError(this.player);
          }
        }
      };
      // player
      this.player = videojs(videoObj, videoOptions, function() {
        // events
        const DEFAULT_EVENTS = [
          "loadeddata",
          "canplay",
          "canplaythrough",
          "play",
          "pause",
          "waiting",
          "timeupdate",
          "playing",
          "volumechange",
          "ended",
          "error"
        ];
        const events = DEFAULT_EVENTS.concat(self.events).concat(
          self.globalEvents
        );
        // watch events
        const onEdEvents = {};
        for (let i = 0; i < events.length; i++) {
          if (
            typeof events[i] === "string" &&
            onEdEvents[events[i]] === undefined
          ) {
            (event => {
              onEdEvents[event] = null;
              this.on(event, () => {
                emitPlayerState(event, true);
              });
            })(events[i]);
          }
        }
        //$(":root").css("--click-here-to-proceed", "PLAY");
        // player readied
        self.$emit("ready", this);
      });
      setTimeout(() => {
        vPlayer = this.player;
      }, 2000);
      vm = this;
    },
    dispose(callback) {
      if (this.player && this.player.dispose) {
        if (this.player.techName_ !== "Flash") {
          this.player.pause && this.player.pause();
        }
        this.player.dispose();
        this.player = null;
        this.$nextTick(() => {
          this.reseted = false;
          this.$nextTick(() => {
            this.reseted = true;
            this.$nextTick(() => {
              callback && callback();
            });
          });
        });
      }
    },
    onError() {
      console.log(vPlayer);
      console.log(vm);
      //setInterval(function () {
      //  vm.initialize();
      //  setTimeout(() => {
      //    vPlayer.play();
      //  }, 2000);
      //}, 5000);
      //setTimeout(() => {
      //  console.log(e);
      //}, 5000);
      //"<img src="/img/sand-clock.93c703c7.svg" width="45px" class="nb-3">"
      //alert(e.error_.code);
      //if (e.error_.code > 0) {
      //  setTimeout(() => {
      //    let errorContainer = document.querySelector(".vjs-error-display");
      //    if (errorContainer) {
      //      //alert("");
      //      errorContainer.innerHTM =
      //        "<img src='/img/sand-clock.93c703c7.svg' width='45px' class='nb-3'>";
      //    }
      //  }, 5000);
      //}
      //this.hasError = true;
      //this.errorMsg = e.error_.message;
    }
  },
  watch: {
    options: {
      deep: true,
      handler(options) {
        this.dispose(() => {
          if (options && options.sources && options.sources.length) {
            this.initialize();
          }
        });
      }
    }
    //volume: function (val) {
    //  alert(val);
    //},
  },

  mounted() {
    if (!this.player) {
      this.initialize();
      vPlayer = this.player;
    } else {
      //
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  }
};
</script>
